import NoInternetConnection from './NoInternetConnection';

export default NoInternetConnection;
